import styled, { css } from 'styled-components';
import CommonItemInfo from './CommonItemInfo';

const internalItemStyles = css`
`;

const InternalItem = styled(({ className, item, toggleLike }) => (
  <CommonItemInfo className={className} item={item} toggleLike = {toggleLike} />
))`${internalItemStyles}`;

export default InternalItem;